import { ComplianceMetadataState } from '../state/compliance-metadata.state';
import {
    getPriorContractMetadataSuccess,
    getPriorContractMetadataFailure
} from 'src/app/compliance/store/actions/compliance-metadata.actions';
import { Action, createReducer, on } from '@ngrx/store';

const initialState: ComplianceMetadataState = {
    metadataFields: [],
    error: null
};

const reducer = createReducer(
    initialState,

    on(getPriorContractMetadataSuccess, (state, action) => ({
        ...state,
        metadataFields: action.result
    })),

    on(getPriorContractMetadataFailure, (state, action) => ({
        ...state,
        error: action.error
    }))
);

export function complianceMetadataReducer(state: ComplianceMetadataState | undefined, action: Action) {
    return reducer(state, action);
}
